import _ from 'lodash';
import { createSelector } from 'reselect';

import { extendInvestorFeatureCode } from 'utils/investorFeatureCodes';
import searchItems from 'utils/searchItems';

import { getIsFromInternalCompany } from 'store/auth/selectors';
import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

export const selectInvestorFeatureCodes = createSelector(
  [getSystem, getIsFromInternalCompany],
  ({ investorFeatureCodes }, isInternalCompany) =>
    _.reduce(
      investorFeatureCodes,
      (acc, i) => {
        acc[i.id] = extendInvestorFeatureCode(i, { isInternalCompany });

        return acc;
      },
      {},
    ),
);

export const selectInvestorFeatureCodesValues = createSelector(
  [selectInvestorFeatureCodes],
  investorFeatureCodes => _.sortBy(investorFeatureCodes, [({ name }) => _.toLower(name)]),
);

export const selectInvestorFeatureCodesOptions = createSelector(
  [selectInvestorFeatureCodesValues],
  investorFeatureCodes =>
    investorFeatureCodes.map(({ id, extendedName }) => ({
      name: extendedName,
      value: id,
    })),
);

export const selectFilteredInvestorFeatureCodes = createSelector(
  getDebouncedSearchValue,
  selectInvestorFeatureCodesValues,
  searchItems(investorFeatureCode => [investorFeatureCode.name]),
);
